<i [class]="iconClass" [ngStyle]="styles">

</i>
<span *ngIf="label">{{label}}</span>
